var _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4698_420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 0.666664H16.8973V16.8975H0.666626V0.666664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4698_420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78234 1.91666C4.9965 1.91666 1.9165 4.99583 1.9165 8.78166C1.9165 12.5675 4.9965 15.6475 8.78234 15.6475C12.5673 15.6475 15.6473 12.5675 15.6473 8.78166C15.6473 4.99583 12.5673 1.91666 8.78234 1.91666ZM8.78234 16.8975C4.30734 16.8975 0.666504 13.2567 0.666504 8.78166C0.666504 4.30666 4.30734 0.666664 8.78234 0.666664C13.2573 0.666664 16.8973 4.30666 16.8973 8.78166C16.8973 13.2567 13.2573 16.8975 8.78234 16.8975Z",
    fill: "#6C6C6C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4698_420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3666 13.7558H17.5533V17.9347H13.3666V13.7558Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4698_420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9285 17.9347C16.7693 17.9347 16.6093 17.8739 16.4868 17.7522L13.5501 14.8239C13.306 14.5797 13.3051 14.1839 13.5493 13.9397C13.7926 13.6939 14.1885 13.6956 14.4335 13.9381L17.3701 16.8672C17.6143 17.1114 17.6151 17.5064 17.371 17.7506C17.2493 17.8739 17.0885 17.9347 16.9285 17.9347Z",
    fill: "#6C6C6C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchs);
export default __webpack_public_path__ + "static/media/searchs.43751365.svg";
export { ForwardRef as ReactComponent };